var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import Service from "./Service.js";
import { getRaf, getCancelRaf } from "../utils/nextFrame.js";
class Raf extends Service {
  constructor() {
    super(...arguments);
    __publicField(this, "isTicking", false);
    __publicField(this, "id", 0);
    __publicField(this, "raf", getRaf());
    __publicField(this, "cancelRaf", getCancelRaf());
    __publicField(this, "props", {
      time: performance.now()
    });
  }
  init() {
    this.isTicking = true;
    this.loop();
  }
  loop() {
    this.updateProps();
    this.trigger(this.props);
    if (!this.isTicking) {
      return;
    }
    this.id = this.raf(() => this.loop());
  }
  kill() {
    this.cancelRaf(this.id);
    this.isTicking = false;
  }
  updateProps() {
    this.props.time = window.performance.now();
    return this.props;
  }
}
let instance;
let raf;
function useRaf() {
  if (!raf) {
    if (!instance) {
      instance = new Raf();
    }
    raf = {
      add: instance.add.bind(instance),
      remove: instance.remove.bind(instance),
      has: instance.has.bind(instance),
      props: instance.updateProps.bind(instance)
    };
  }
  return raf;
}
export {
  useRaf as default
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
